//common
import './common';

//components
import Tab from './blocks/tab'
import ProductCarousel from './blocks/slider-product'
import RecipesCarousel from './blocks/slider-recipes'


addEventListener('ajax:update-complete', () => {
    ProductCarousel.init();
    RecipesCarousel.init();
    Tab.initHandler();
})
